import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { LocationSwitcherService, Location } from '../../services/location-switcher/location-switcher.service';

@Component({
  selector: 'app-location-display',
  templateUrl: './location-display.component.html',
  styleUrls: ['./location-display.component.scss']
})
export class LocationDisplayComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();

  currentLocation: Location | null = null;

  constructor(
    private locationSwitcherService: LocationSwitcherService
  ) { }

  ngOnInit(): void {
    // Subscribe to current location
    this.locationSwitcherService.currentLocation$
      .pipe(takeUntil(this.destroy$))
      .subscribe(location => {
        this.currentLocation = location;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getCurrentLocationDisplay(): string {
    if (!this.currentLocation) {
      return 'No location selected';
    }

    return `${this.currentLocation.name} (${this.currentLocation.id})`;
  }
}
